module.exports = __webpack_public_path__ + "img/no-leads.a036c41f.svg";